import { Link } from 'react-router-dom';
import { Mail, MapPin } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_0848332d-e034-4129-a373-6813f066dde6/artifacts/l1pyibi2_logo-highres.png" 
                alt="AirVia - cheap domestic flight booking India" 
                className="h-16 w-auto"
              />
            </div>
            <p className="text-slate-400 text-sm">
              India's first subscription-based flight booking service. Save up to 50% on domestic flights.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold mb-4 text-lg">Quick Links</h3>
            <ul className="space-y-2 text-slate-400 text-sm">
              <li><Link to="/" className="hover:text-amber-600 transition-colors">Home</Link></li>
              <li><Link to="/subscription-plans" className="hover:text-amber-600 transition-colors">Get Started</Link></li>
              <li><Link to="/blog" className="hover:text-amber-600 transition-colors">Blog</Link></li>
              <li><Link to="/faq" className="hover:text-amber-600 transition-colors">FAQ</Link></li>
              <li><Link to="/contact" className="hover:text-amber-600 transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          {/* Popular Routes */}
          <div>
            <h3 className="font-semibold mb-4 text-lg">Popular Routes</h3>
            <ul className="space-y-2 text-slate-400 text-sm">
              <li><Link to="/flights/bangalore-to-delhi" className="hover:text-amber-600 transition-colors">Bangalore → Delhi</Link></li>
              <li><Link to="/flights/mumbai-to-delhi" className="hover:text-amber-600 transition-colors">Mumbai → Delhi</Link></li>
              <li><Link to="/flights/hyderabad-to-bangalore" className="hover:text-amber-600 transition-colors">Hyderabad → Bangalore</Link></li>
              <li><Link to="/flights/chennai-to-delhi" className="hover:text-amber-600 transition-colors">Chennai → Delhi</Link></li>
              <li><Link to="/flights/pune-to-mumbai" className="hover:text-amber-600 transition-colors">Pune → Mumbai</Link></li>
            </ul>
          </div>

          {/* Contact & Legal */}
          <div>
            <h3 className="font-semibold mb-4 text-lg">Contact</h3>
            <ul className="space-y-3 text-slate-400 text-sm">
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4" />
                hello@airviaindia.com
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0" />
                <span>OXFORD TOWER, 139/88 HAL OLD AIRPORT RD, H.A.L II Stage, Bengaluru 560008</span>
              </li>
            </ul>
            <div className="mt-4 pt-4 border-t border-slate-800">
              <ul className="space-y-2 text-slate-400 text-sm">
                <li><a href="/privacy-policy" className="hover:text-amber-600 transition-colors">Privacy Policy</a></li>
                <li><a href="/terms-of-service" className="hover:text-amber-600 transition-colors">Terms of Service</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-8 text-center text-slate-400 text-sm">
          <p>&copy; {new Date().getFullYear()} AirVia. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
